import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { filter, indexOf } from 'lodash';
import OpportunityTable from './index';

class OpportunityModal extends Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    const {
      show,
    } = this.props;
    if (!show) {
      return null;
    }
    return (
      <OpportunityTable
        {...this.props.tableConfigs}
        opportunities={this.props.opportunities}
        enableFullScreen
        fullScreenMode
        showExcluedReason={this.props.showExcluedReason}
        onExitFullScreen={this.props.onClose}
      />
    );
  }
}


OpportunityModal.propTypes = {
  opportunities: PropTypes.arrayOf(PropTypes.shape({
    opportunity_id: PropTypes.string.isRequired,
  })).isRequired,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  tableConfigs: PropTypes.shape({}),
  getOpportunities: PropTypes.func,
  showExcluedReason: PropTypes.bool,
};
OpportunityModal.defaultProps = {
  onClose: () => {},
  show: false,
  tableConfigs: {},
  getOpportunities: null,
  showExcluedReason: false,
};

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const opportunities = ownProps.getOpportunities ? ownProps.getOpportunities(state) : [];
  const newOpportunities = filter(opportunities, opportunity => (indexOf(ownProps.opportunityIds || [], opportunity.opportunity_id) >= 0));
  return {
    opportunities: newOpportunities,
    show: newOpportunities.length > 0,
  };
}

export default connect(mapStateToProps)(OpportunityModal);
